import React from "react";


function Timing() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/makreri.jpeg)',backgroundSize:'cover',backgroundPosition:'center'}}></div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px',padding:'50px',backgroundSize:'cover',backgroundAttachment:'fixed'}}>
        <div className="row">
            <div className="col-md-7" style={{background:'#ffffffd2',padding:'50px',border:'1px solid silver'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange'}}>
                    <div className="col-md-12 middle">
                       <center><p className="enquiry">Darshan Timings / ദർശന സമയം</p> </center>                                         
                    </div>
                </div>
                <div className="row" style={{marginBottom:'50px',paddingTop:'15px'}}>
                    {/* <center>
                          <h3 className="theading" style={{fontSize:'20px',fontWeight:'700',marginTop:'-20px',textAlign:'center'}}>Alpashi Festival from 16-10-2025 to 31-10-2025</h3>
                      </center> */}
                    {/* first */}
                   
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            {/* <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">08:30 AM to 10:00 AM</li>
                                <li className="timelist">10:30 AM to 11:15 AM</li> 
                          </ul>*/}
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                {/* <ul>
                                    <li className="timelist">4:30 PM to 6:15 PM</li>
                                    <li className="timelist">6:45 PM to 7:20 PM</li>
                                </ul> */}
                      </div>
                    </div>
                    
                </div>
           </div> 
            <div class="col-md-5" style={{backgroundImage:'url(./images/makreri.jpeg)',backgroundSize:'cover',backgroundPosition:'center'}}>
                
            </div>
        </div>
        
        
      </div>
    </div>
  );
}

export default Timing;